import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Es un plan, una dieta o un recetario?',
  answer: 'No. Nutrición que Sostiene no es una dieta ni un plan rígido, y tampoco es solo un recetario. Es un sistema completo que combina nutrición, digestión, energía y relación con la comida, pensado para acompañarte en la vida real, sin exigencias extremas.'
}, {
  question: '¿Sirve aunque ya haya intentado comer saludable antes?',
  answer: 'Sí. De hecho, está especialmente pensado para personas que ya intentaron "comer sano" pero no lograron sostenerlo. El enfoque no es hacerlo perfecto, sino hacerlo posible y mantenible en el tiempo.'
}, {
  question: '¿Necesito seguirlo de forma estricta para ver resultados?',
  answer: 'No. El sistema está diseñado para ser flexible, no restrictivo. Podés adaptarlo a tus tiempos, gustos y contexto, sin culpa si algún día no sale todo como esperás.'
}, {
  question: '¿Cómo accedo al contenido y por cuánto tiempo?',
  answer: 'El acceso es 100% digital e inmediato. Una vez que ingresás, el material es tuyo para siempre, para leer, aplicar y volver cuando lo necesites.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4 max-w-3xl mx-auto" data-id="element-9">
      {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg bg-white overflow-hidden shadow-sm" data-id="element-10">
          <button className="w-full px-6 py-4 text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-11">
            <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-12">
              {faq.question}
            </span>
            {openIndex === index ? <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-13" /> : <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" data-id="element-14" />}
          </button>

          {openIndex === index && <div className="px-6 pb-6 pt-2 text-gray-600 leading-relaxed border-t border-gray-100 bg-gray-50/50" data-id="element-15">
              {faq.answer}
            </div>}
        </div>)}
    </div>;
}